import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import Functions from "../../../../services/Functions";
import SmallPieGraph from "../../../general/SmallPieGraph";
import PieGraph from "../../../general/PieGraph";
import styles from "./HealthL3.module.css";

function HealthL3({ distrito, healthValues, setHealthProperties3 }) {
  const {
    frequenciaExameValue,
    atendimentoAmbulanciaValue,
    sistemaSaudeValue,
    usoMedicamentoValue,
    dificuldadeAtendimentoValue,
    qualidadeSSMunicipalValue,
    qualidadeSSRuralValue,
    possuiDoencaCronicaValue,
    tipoDoencaCronicaValue,
    programaSaudeRuralValue,
  } = healthValues;

  const {
    setPossuiDoencaCronicaValue,
    setTipoDoencaCronicaValue,
    setProgramaSaudeRuralValue,
    setPossuiDoencaCronicaImage,
    setTipoDoencaCronicaImage,
    setProgramaSaudeRuralImage,
  } = setHealthProperties3;

  const [possuiDoencaCronica, setPossuiDoencaCronica] = useState(null);
  const [tipoDoencaCronica, setTipoDoencaCronica] = useState(null);
  const [programaSaudeRural, setProgramaSaudeRural] = useState(null);
  const [possuiDoencaCronicaOldValue, setPossuiDoencaCronicaOldValue] = useState(null);
  const [tipoDoencaCronicaOldValue, setTipoDoencaCronicaOldValue] = useState(null);
  const [programaSaudeRuralOldValue, setProgramaSaudeRuralOldValue] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [possuiDoencaCronica, tipoDoencaCronica, programaSaudeRural] =
          await Promise.all([
            Api.getPossuiDoencasCronicas(distrito),
            Api.getTipoDoencasCronicas(distrito),
            Api.getProgramaSaudeRural(distrito),
          ]);
        setPossuiDoencaCronica(Functions.buildSmallPieGraphParams(possuiDoencaCronica));
        setTipoDoencaCronica(Functions.buildPieGraphParams2(tipoDoencaCronica));
        setProgramaSaudeRural(Functions.buildSmallPieGraphParams(programaSaudeRural));
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [distrito]);

  if (loading) return <div className={styles.healthL3}></div>;

  const onPossuiDoencaCronicaClick = (value) => {
    setPossuiDoencaCronicaValue(value);
  };

  const onTipoDoencaCronicaClick = (value) => {
    setTipoDoencaCronicaValue(value);
  };

  const onProgramaSaudeRuralClick = (value) => {
    setProgramaSaudeRuralValue(value);
  };

  const onPossuiDoencaCronicaOldValue = (value) => {
    setPossuiDoencaCronicaOldValue(value);
  };

  const onTipoDoencaCronicaOldValue = (value) => {
    setTipoDoencaCronicaOldValue(value);
  };

  const onProgramaSaudeRuralOldValue = (value) => {
    setProgramaSaudeRuralOldValue(value);
  };

  return (
    <div className={styles.generalConditionL1}>
      {possuiDoencaCronica && (
        <div className={styles.smallPiegraph}>
          <SmallPieGraph
            data={possuiDoencaCronica}
            text="POSSUI DOENÇA CRÔNICA"
            onLegendClick={onPossuiDoencaCronicaClick}
            currentValue={possuiDoencaCronicaValue}
            oldValue={possuiDoencaCronicaOldValue}
            onOldValue={onPossuiDoencaCronicaOldValue}
            onImageReady={setPossuiDoencaCronicaImage}
          />
        </div>
      )}

      {tipoDoencaCronica && (
        <div className={styles.smallPiegraph}>
          <PieGraph
            data={tipoDoencaCronica}
            text="TIPO DE DOENÇA"
            onLegendClick={onTipoDoencaCronicaClick}
            currentValue={tipoDoencaCronicaValue}
            oldValue={tipoDoencaCronicaOldValue}
            onOldValue={onTipoDoencaCronicaOldValue}
            onImageReady={setTipoDoencaCronicaImage}
          />
        </div>
      )}

      {programaSaudeRural && (
        <div className={styles.smallPiegraph}>
          <SmallPieGraph
            data={programaSaudeRural}
            text="PROGRAMA DE SAÚDE RURAL"
            onLegendClick={onProgramaSaudeRuralClick}
            currentValue={programaSaudeRuralValue}
            oldValue={programaSaudeRuralOldValue}
            onOldValue={onProgramaSaudeRuralOldValue}
            onImageReady={setProgramaSaudeRuralImage}
          />
        </div>
      )}
    </div>
  );
}

export default HealthL3;
